export default __webpack_public_path__ + "static/media/AdDinosaurs_06.7583107d.png";